import axios from 'axios';

const API = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
const HANDOFF_KEY = 'tribe_portal_access_handoff';
const HANDOFF_TTL_MS = 15000;
const pending = new Map();

function validateAccess(value) {
  if (typeof value?.hasHostAccess !== 'boolean' ||
      typeof value?.hasReferralPartnerAccess !== 'boolean') {
    throw new Error('Unable to verify portal access.');
  }
  return {
    hasHostAccess: value.hasHostAccess,
    hasReferralPartnerAccess: value.hasReferralPartnerAccess,
  };
}

// Share simultaneous checks, including React Strict Mode's effect replay.
export function getPortalAccess(token) {
  if (!token) return Promise.reject(new Error('Please sign in to access your portals.'));
  if (pending.has(token)) return pending.get(token);
  const request = axios.get(`${API}/referral-partners/me`, {
    params: { accessOnly: '1' },
    headers: { Authorization: `Bearer ${token}` },
  }).then(response => validateAccess(response.data))
    .finally(() => pending.delete(token));
  pending.set(token, request);
  return request;
}

export function clearPortalAccessHandoff() {
  try { sessionStorage.removeItem(HANDOFF_KEY); } catch {}
}

// A one-use UI handoff for the full-page login redirect, not an authorization
// cache. Dashboard APIs continue enforcing their own roles and agreement gates.
export function rememberPortalAccessHandoff(token, access) {
  try {
    sessionStorage.setItem(HANDOFF_KEY, JSON.stringify({
      token, access: validateAccess(access), createdAt: Date.now(),
    }));
  } catch {}
}

export function takePortalAccessHandoff(token) {
  try {
    const raw = sessionStorage.getItem(HANDOFF_KEY);
    clearPortalAccessHandoff();
    if (!raw) return null;
    const saved = JSON.parse(raw);
    const age = Date.now() - saved.createdAt;
    if (!token || saved.token !== token || !Number.isFinite(age) ||
        age < 0 || age > HANDOFF_TTL_MS) return null;
    return validateAccess(saved.access);
  } catch {
    return null;
  }
}
